module.exports = __webpack_public_path__ + "img/12.98af5843.svg";